import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import {
  CImage,
  CSidebar,
  CSidebarBrand,
  CSidebarNav,
  CSidebarToggler,
} from "@coreui/react-pro";

import { AppSidebarNav } from "./AppSidebarNav";

import { setSideBar, setAside, setTheme } from "./../Slices/SideBarSlice";

import SimpleBar from "simplebar-react";
import "simplebar/dist/simplebar.min.css";

// sidebar nav config
import navigation from "../_nav";

const AppSidebar = () => {
  const dispatch = useDispatch();
  const [unfoldable, setUnFoldable] = useState(false);
  const sidebarShow = useSelector(
    ({ sideBarState }) => sideBarState.sidebarShow
  );

  return (
    <CSidebar
      position="fixed"
      unfoldable={unfoldable}
      visible={sidebarShow}
      onVisibleChange={(visible) => {
        dispatch(setSideBar(visible));
      }}
      style={{ position: "fixed" }}
    >
      <CSidebarBrand
        className="d-none d-md-flex"
        to="/"
        style={{ display: "none" }}
      >
        {!unfoldable ? (
          <CImage src="/sabakLogowBG.png" height={41} alt="Logo" />
        ) : (
          <CImage src="/favicon.ico" height={35} alt="Logo" />
        )}
      </CSidebarBrand>
      <CSidebarNav>
        <SimpleBar>
          <AppSidebarNav items={navigation} />
        </SimpleBar>
      </CSidebarNav>
      <CSidebarToggler
        className="d-none d-lg-flex"
        style={{ display: "none" }}
        onClick={() => setUnFoldable(!unfoldable)}
      />
    </CSidebar>
  );
};

export default React.memo(AppSidebar);
